import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (sessionId) {
      pollStatus(sessionId, 0);
    } else {
      setStatus("error");
    }
  }, [sessionId]);

  const pollStatus = async (sid, attempt) => {
    if (attempt >= 5) {
      setStatus("timeout");
      return;
    }
    try {
      const res = await axios.get(`${API}/checkout/status/${sid}`);
      if (res.data.payment_status === "paid") {
        setStatus("paid");
        return;
      }
      if (res.data.status === "expired") {
        setStatus("expired");
        return;
      }
      setTimeout(() => pollStatus(sid, attempt + 1), 2000);
    } catch {
      setStatus("error");
    }
  };

  return (
    <div data-testid="payment-success-page" className="min-h-[60vh] flex items-center justify-center py-20">
      <div className="max-w-md text-center px-6">
        {status === "checking" && (
          <div>
            <Loader2 className="w-10 h-10 text-[#C8A97E] mx-auto mb-4 animate-spin" />
            <h2 className="font-serif text-2xl font-semibold text-[#1C2E4A] mb-2">
              Processing Payment...
            </h2>
            <p className="text-sm text-[#595959]">Please wait while we confirm your payment.</p>
          </div>
        )}
        {status === "paid" && (
          <div>
            <CheckCircle2 className="w-12 h-12 text-[#8F9779] mx-auto mb-4" />
            <h2 className="font-serif text-2xl font-semibold text-[#1C2E4A] mb-2">
              Payment Successful!
            </h2>
            <p className="text-sm text-[#595959] mb-6">
              Thank you for your payment. We will be in touch shortly to begin setting up your church school system.
            </p>
            <Link to="/" className="bg-[#1C2E4A] text-white hover:bg-[#152238] px-8 py-3 rounded-md transition-colors font-medium inline-block">
              Return Home
            </Link>
          </div>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <div>
            <h2 className="font-serif text-2xl font-semibold text-[#1C2E4A] mb-2">
              {status === "expired" ? "Session Expired" : "Payment Status Unknown"}
            </h2>
            <p className="text-sm text-[#595959] mb-6">
              If you completed the payment, please contact us at acsvirtualchurch@gmail.com for confirmation.
            </p>
            <Link to="/start-a-church-school" className="text-sm text-[#C8A97E] hover:underline font-medium">
              Try Again
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
